export default function getHTMLElementScroll(_0x525f41){return{'scrollLeft':_0x525f41['scrollLeft'],'scrollTop':_0x525f41['scrollTop']};}